// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.data-balance-rechange .bank-label{\n    width: 210px;\n    font-size: 14px;\n    color: #1D3A71;\n    font-weight: 500;  font-family: 'Inter-Medium';\n}\n", ""]);
// Exports
module.exports = exports;
